import { environment } from '../../../environments/environment';

/**
 * Verify if provided value is number regardles of type ( e.g. we check if string contain number and can be parsed  )
 *
 * @param value value eto be checked
 * @returns
 */
export function isNumber(value: string | number | [] | {}): boolean {
  if (value == null || value === '' || Array.isArray(value)) {
    return false;
  }

  const num = String(value).replace(',', '.');

  if (num.split('.').length > 2 || num.split(',').length > 2) {
    return false;
  }

  if (isNaN(Number(num))) {
    return false;
  }

  return /^[-+]?(Infinity|\d+)([.,]\d+)?$/.test(value.toString());
}

/**
 * Allow to treat number inside string type with parseFloat or decimalPipe.transform functions with no error.
 * cases like '1.000.232,3' will be ignored ( i assume delimiters are not valid number in type string)
 *
 * @param value string which contain number
 * @returns string which contain number but with '.' as separator
 */
export function replaceCommaWithDot(value: string): string {
  if (typeof value === 'string' && value.indexOf('.') === -1 && value.indexOf(',') !== -1) {
    const commaCount = (value.match(/,/g) || []).length;
    if (commaCount === 1) {
      return value.replace(/,/g, '.');
    }
  }

  return value;
}

export function getProperRoundingRule(value: number | string): string {
  let numValue: number;
  if (typeof value === 'number') {
    // If the value is already a number, use it directly
    numValue = value;
  } else if (typeof value === 'string' && /\d+/.test(value)) {
    // If the value is a string containing a number, parse it to a number
    numValue = parseFloat(value);
  } else {
    // If the value is neither a number nor a string containing a number
    if (environment.env !== 'production') {
      console.log(
        'Invalid input value, no rounding rules applied. Value: ' + JSON.stringify(value)
      );
    }

    return null;
  }

  const bigValue = numValue >= 100;
  const mediumValue = numValue < 100 && numValue >= 10;
  const smallValue = numValue < 10 && numValue >= 1;
  const verySmallValue = numValue < 1;

  if (bigValue) {
    return '1.0-0';
  } else if (mediumValue) {
    return '1.0-1';
  } else if (smallValue) {
    return '1.0-1';
  } else if (verySmallValue) {
    return '1.0-1';
  }
}
